import * as XLSX from 'xlsx';
import {
    getAsRepairExcelColumnMapping,
    getAsRepairExcelFieldMap,
} from './asRepairExcelImport';
import {
    AS_REPAIR_MANAGEMENT_SCOPE,
    formatAsRepairQuantityDisplay,
    getAsRepairFieldDisplayValue,
    normalizeAsRepairFormConfig,
    parseQuantityValue,
} from './asRepairFormConfig';

const cellValueForExport = (field, row, config, role) => {
    if (!field) {
        return '';
    }
    const raw = getAsRepairFieldDisplayValue(field, row, config);
    if (raw == null || raw === '') {
        return '';
    }
    if (field.inputType === 'quantity' || role === 'totalQty') {
        const text = formatAsRepairQuantityDisplay(raw);
        if (text !== '') {
            return parseQuantityValue(raw);
        }
        return '';
    }
    return String(raw);
};

/** A/S 행 → 업로드와 동일한 열 배열 (헤더 없음, 개인 관리는 A/B/C/F/G/H 위치 유지) */
export const buildAsRepairExcelRows = (rows, config, { managementScope } = {}) => {
    const list = Array.isArray(rows) ? rows : [];
    const scope = managementScope || AS_REPAIR_MANAGEMENT_SCOPE.REPAIR;
    const formConfig = normalizeAsRepairFormConfig(config);
    const columnMapping = getAsRepairExcelColumnMapping(scope);
    const fieldMap = getAsRepairExcelFieldMap(formConfig, scope);
    const maxIndex = columnMapping.reduce((max, col) => Math.max(max, col.index), 0);

    return list.map((row) => {
        const line = Array(maxIndex + 1).fill('');
        columnMapping.forEach(({ index, role }) => {
            line[index] = cellValueForExport(fieldMap[role], row, formConfig, role);
        });
        return line;
    });
};

const buildExportFileName = (managementScope) => {
    const now = new Date();
    const pad = (n) => String(n).padStart(2, '0');
    const stamp = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}`;
    const prefix = managementScope === AS_REPAIR_MANAGEMENT_SCOPE.PERSONAL
        ? 'AS개인목록'
        : 'AS수리목록';
    return `${prefix}_${stamp}.xlsx`;
};

/** 선택한 A/S 목록을 업로드와 동일한 형식의 XLSX로 저장 */
export const downloadAsRepairExcelFile = (rows, config, { fileName, managementScope } = {}) => {
    const scope = managementScope || AS_REPAIR_MANAGEMENT_SCOPE.REPAIR;
    const dataRows = buildAsRepairExcelRows(rows, config, { managementScope: scope });
    if (dataRows.length === 0) {
        return { ok: false, reason: 'empty' };
    }

    const sheet = XLSX.utils.aoa_to_sheet(dataRows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, sheet, 'Sheet1');
    XLSX.writeFile(workbook, fileName || buildExportFileName(scope));
    return { ok: true, rowCount: dataRows.length };
};
